import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import useVisibilitySensor from './useVisibilitySensor';
export const ScrollableVisibilitySensor = ({ children }) => {
    const { visibilityRef, isVisible } = useVisibilitySensor();
    return _jsx(_Fragment, { children: children({ visibilityRef, isVisible }) });
};
export default ScrollableVisibilitySensor;
//# sourceMappingURL=ScrollableVisibilitySensor.js.map